// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardDiscover-cls1_ggw","cls2":"BigCardDiscover-cls2_4o_ BigCardDiscover-cls1_ggw"};